import axios from './axios';

const Axios = axios('dex-api');

export async function sendMetaMaskRequest(account) {
  return Axios.post('use_metamask', { walletAddress: account }).then(({ data }) => data);
}
